<header class="flex header">
  <h2>
    @if (itemMaster && !duplicateItemMaster) {
      {{ 'Common_Edit' | translateWF: 'Edit' }}
    } @else if (!itemMaster) {
      {{ 'Common_Create' | translateWF: 'Create' }}
    }
    Item Master {{ subTitle }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" [disabled]="isLoading" />
</header>
@if (isLoading) {
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
}
<section class="content">
  <p-panel
    *ngIf="helpCreateItem"
    [toggleable]="true"
    [collapsed]="false"
    header="Suggested item name"
    styleClass="border border-green-500 bg-green-50 text-sm"
    headerStyleClass="text-green-700 font-semibold"
    [showHeader]="true"
  >
    <div class="text-black mb-3">
      {{ suggestedName }}
    </div>

    <div class="row-end-stretch">
      <p-button label="Apply" class="p-button-sm" [disabled]="!canEdit" (onClick)="propagateSuggestedName()"></p-button>
    </div>
  </p-panel>
  <p-message *ngIf="duplicateItemMaster" severity="warn">Duplicating item master</p-message>

  <p-panel [header]="'ItemMaster_Modal_General_Information' | translateWF: 'General Information'" [formGroup]="itemMasterFormGroup">
    <p-card>
      <div class="col">
        <!-- Base PD Code (Yarn / Fabric / Greige) -->
        @if (baseCode) {
          <div class="form-box">
            <label>{{ baseCode.label }}</label>
            <input pInputText type="text" [value]="baseCode.code" class="w-full" disabled />
          </div>
        }

        <!-- Status -->
        <div class="form-box">
          <label for="status">
            {{ 'ItemMaster_TableStatus' | translateWF: 'Status' }}
          </label>
          <p-select
            formControlName="status"
            [options]="_setOptionsForPrimeNg(statuses)"
            optionValue="value"
            optionLabel="label"
            [placeholder]="'ItemMaster_SelectStatus' | translateWF: 'Select a Status'"
            fluid
            class="w-full"
          />
        </div>

        <div class="flex gap-[0.5rem] items-start">
          <i class="pi pi-language mt-[3px]"></i>
          {{ 'Common_Spanish_Translate' | translateWF: 'Spanish Translate' }}
          <p-toggleswitch [formControl]="spanishTranslate" />
        </div>

        <!-- itemDisplayName -->
        <div class="form-box" formGroupName="itemDisplayName">
          <label>
            {{ 'ItemMaster_Modal_ItemName' | translateWF: 'Item Name' }}
          </label>

          <p-inputgroup>
            <p-inputgroup-addon> EN </p-inputgroup-addon>
            <input pInputText type="text" class="w-full" formControlName="en" />
          </p-inputgroup>
          @if (submittedForm && itemMasterFormGroup.get('itemDisplayName.en')?.invalid) {
            <div class="text-red-500 text-sm">
              <div *ngIf="itemMasterFormGroup.get('itemDisplayName.en')?.errors?.['required']">Item name is required.</div>
            </div>
          }
          @if (spanishTranslate.value) {
            <p-inputgroup class="mt-[1rem]">
              <p-inputgroup-addon> ES </p-inputgroup-addon>
              <input formControlName="es" pInputText type="text" class="w-full"
            /></p-inputgroup>
          }
        </div>
        <!-- itemLongDisplayName -->
        <div class="form-box" formGroupName="itemLongDisplayName">
          <label>
            {{ 'ItemMaster_Modal_ItemLongName' | translateWF: 'Item Long Name' }}
          </label>
          <p-inputgroup>
            <p-inputgroup-addon> EN </p-inputgroup-addon>
            <input pInputText type="text" class="w-full" formControlName="en" />
          </p-inputgroup>
          @if (spanishTranslate.value) {
            <p-inputgroup class="mt-[1rem]">
              <p-inputgroup-addon> ES </p-inputgroup-addon>
              <input formControlName="es" pInputText type="text" class="w-full"
            /></p-inputgroup>
          }
        </div>
        <!-- itemDescription -->
        <div class="form-box" formGroupName="itemDescription">
          <label>
            {{ 'ItemMaster_Modal_ItemDescription' | translateWF: 'Item Description' }}
          </label>
          <p-inputgroup>
            <p-inputgroup-addon> EN </p-inputgroup-addon>
            <textarea
              rows="2"
              cols="30"
              pTextarea
              class="w-full"
              formControlName="en"
              [ngClass]="{
                'ng-invalid ng-dirty': submittedForm && itemMasterFormGroup.get('itemDescription.en')?.invalid,
              }"
            ></textarea>
          </p-inputgroup>
          @if (submittedForm && itemMasterFormGroup.get('itemDescription.en')?.invalid) {
            <div class="text-red-500 text-sm">
              <div *ngIf="itemMasterFormGroup.get('itemDescription.en')?.errors?.['required']">Item description is required.</div>
            </div>
          }
          @if (spanishTranslate.value) {
            <p-inputgroup class="mt-[1rem]">
              <p-inputgroup-addon> ES </p-inputgroup-addon>
              <textarea rows="2" cols="30" pTextarea class="w-full" formControlName="es"></textarea>
            </p-inputgroup>
          }
        </div>
        <!-- Sites + ItemLocalName per site -->
        @if (canAssignSites) {
          <div class="form-box">
            <label for="siteIds">
              {{ 'ItemMaster_Modal_Sites' | translateWF: 'Site(s)' }}
            </label>
            <p-multiSelect
              appendTo="body"
              [options]="availableSites"
              optionLabel="name"
              optionValue="id"
              formControlName="siteIds"
              display="chip"
              [placeholder]="'ItemMaster_Modal_Sites_Placeholder' | translateWF: 'Select sites'"
              class="w-full"
            ></p-multiSelect>
            @if (submittedForm && itemMasterFormGroup.get('siteIds')?.errors?.['required']) {
              <div class="text-red-500 text-sm">
                {{ 'ItemMaster_Modal_Sites_Required' | translateWF: 'At least one site must be selected.' }}
              </div>
            }
          </div>
        }
        @if (canAssignSites && siteLocalNameGroups.length > 0) {
          <div class="form-box">
            <label>
              {{ 'ItemMaster_Modal_SiteProperties' | translateWF: 'Site Properties' }}
            </label>
            <p-accordion [multiple]="true" [(value)]="expandedSiteIds">
              @for (group of siteLocalNameGroups; track group.siteId) {
                <p-accordion-panel [value]="group.siteId">
                  <p-accordion-header>
                    {{ getSiteName(group.siteId) }}
                  </p-accordion-header>
                  <p-accordion-content>
                    <ng-container *ngTemplateOutlet="siteFieldsTpl; context: { $implicit: group.formGroup }"></ng-container>
                  </p-accordion-content>
                </p-accordion-panel>
              }
            </p-accordion>
          </div>
        } @else if (!canAssignSites && siteLocalNameGroups.length > 0) {
          <ng-container *ngTemplateOutlet="siteFieldsTpl; context: { $implicit: siteLocalNameGroups[0].formGroup }"></ng-container>
        }
      </div>
    </p-card>
  </p-panel>

  <ng-template #siteFieldsTpl let-group>
    <div [formGroup]="group">
      <div class="form-box">
        <label>{{ 'ItemMaster_TableInventoryType' | translateWF: 'Inventory Type' }}</label>
        <p-select
          appendTo="body"
          formControlName="inventoryTypeReference"
          [options]="getInventoryTypeOptions(group.get('siteId')?.value)"
          [filter]="true"
          optionValue="id"
          optionLabel="optionDisplayName"
          filterBy="optionDisplayName"
          [placeholder]="'ItemMaster_SelectInventoryType' | translateWF: 'Select a Inventory Type'"
          fluid
          class="w-full"
          [ngClass]="{
            'ng-invalid ng-dirty': submittedForm && group.get('inventoryTypeReference')?.invalid,
          }"
        />
        @if (submittedForm && group.get('inventoryTypeReference')?.errors?.['required']) {
          <div class="text-red-500 text-sm">Inventory Type is required.</div>
        }
      </div>
      <div class="form-box">
        <label>{{ 'ItemMaster_Modal_ItemCategory' | translateWF: 'Item Category' }}</label>
        <p-select
          appendTo="body"
          [options]="getItemCategorySuggestions(group.get('siteId')?.value)"
          [filter]="true"
          optionValue="code"
          optionLabel="icFieldToDisplay"
          filterBy="code"
          [placeholder]="'ItemMaster_SelectItemCategory' | translateWF: 'Select a Item Category'"
          formControlName="itemCategoryCode"
          class="w-full"
          fluid
          [ngClass]="{
            'ng-invalid ng-dirty': submittedForm && group.get('itemCategoryCode')?.invalid,
          }"
        ></p-select>
        @if (submittedForm && group.get('itemCategoryCode')?.errors?.['required']) {
          <div class="text-red-500 text-sm">Item Category is required.</div>
        }
      </div>
      @if (group.get('itemCategoryCode')?.value) {
        <div class="form-box">
          <label>{{ 'ItemMaster_Modal_ItemLowestSubCategory' | translateWF: 'Item Lowest Subcategory' }}</label>
          <p-select
            appendTo="body"
            [group]="true"
            [options]="getCategoryLowestSubCategoriesBySite(group.get('siteId')?.value, group.get('itemCategoryCode')?.value)"
            [filter]="true"
            optionValue="value"
            optionLabel="label"
            filterBy="label"
            [placeholder]="'ItemMaster_SelectLowestSubCategory' | translateWF: 'Select Lowest Subcategory'"
            formControlName="itemLowestSubCategoryCode"
            class="w-full"
            fluid
          >
            <ng-template pTemplate="group" let-g>
              <div class="p-dropdown-item-group-header">
                <hr />
              </div>
            </ng-template>
            <ng-template pTemplate="item" let-item>
              @if (item.index == 0) {
                <strong>{{ item.label }}</strong>
              } @else {
                <div>--- {{ item.label }}</div>
              }
            </ng-template>
          </p-select>
        </div>
      }
      <div class="form-box">
        <label>{{ 'ItemMaster_Modal_ItemLocalName' | translateWF: 'Item Local Name' }}</label>
        <p-inputgroup>
          <p-inputgroup-addon> EN </p-inputgroup-addon>
          <input pInputText type="text" class="w-full" formControlName="en" />
        </p-inputgroup>
        @if (spanishTranslate.value) {
          <p-inputgroup class="mt-[1rem]">
            <p-inputgroup-addon> ES </p-inputgroup-addon>
            <input pInputText type="text" class="w-full" formControlName="es" />
          </p-inputgroup>
        }
      </div>
    </div>
  </ng-template>

  <p-panel [header]="'ItemMaster_Modal_Certifications' | translateWF: 'Certification(s)'" *ngIf="baseYarn">
    <ng-template pTemplate="icons">
      <p-button (click)="populateCertificationsToGeneralInfo()"> Update Name and Description </p-button>
    </ng-template>
    <p-card>
      <div class="form-box">
        @if (!isEditMode) {
          <p-multiSelect
            appendTo="body"
            [options]="getYarnCertifications(baseYarn)"
            optionLabel="name"
            [formControl]="selectedCertifications"
            display="chip"
            placeholder="Select certifications"
          ></p-multiSelect>
        } @else {
          <div *ngIf="selectedCertifications.value.length; else noCert">
            <p-tag *ngFor="let cert of selectedCertifications.value; let i = index" class="m-1">{{ cert.name }}</p-tag>
          </div>
          <ng-template #noCert>No Certifications</ng-template>
        }
      </div>
    </p-card>
  </p-panel>

  <p-panel [header]="'ItemMaster_Modal_Composition' | translateWF: 'Composition'" *ngIf="baseGreige">
    <p-card data-variant="compact">
      <div *ngIf="baseGreige">
        <p-table [value]="yarns" dataKey="code">
          <ng-template pTemplate="header">
            <tr>
              <th>PD Yarn Code</th>
              <th>Description</th>
              <th>Certifications</th>
              <th>Use %</th>
              <th>Item Master Code</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-yarn let-rowIndex="rowIndex">
            <tr *ngIf="getYarnCodeWithCertAndItemMaster(yarn.code) as yarnCertAndItem">
              <td>{{ yarn.code }}</td>
              <td>{{ yarn.longDescription }}</td>
              <td>
                @if (!isEditMode) {
                  <p-multiSelect
                    appendTo="body"
                    [options]="getYarnCertifications(yarn)"
                    optionLabel="name"
                    display="chip"
                    placeholder="Select certifications"
                    [(ngModel)]="yarnCertAndItem.certifications"
                    (onChange)="onCertificationChange($event, yarn)"
                  ></p-multiSelect>
                } @else {
                  <div *ngIf="yarnCertAndItem.certifications.length; else noCert">
                    <p-tag *ngFor="let cert of yarnCertAndItem.certifications; let i = index" class="m-1">{{ cert.name }}</p-tag>
                  </div>
                  <ng-template #noCert>No Certifications</ng-template>
                }
              </td>
              <td>{{ getYarnCodeUsePercentage(yarn.code) }}%</td>
              <td>
                {{ getYarnCodeWithCertAndItemMaster(yarn.code)!.itemMaster ? getYarnCodeWithCertAndItemMaster(yarn.code)!.itemMaster!.fieldToDisplay : 'Not Found' }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </p-panel>

  <p-panel [header]="'ItemMaster_Modal_Classification' | translateWF: 'Classification'" [formGroup]="itemMasterFormGroup">
    <p-card>
      <div class="form-box">
        <label for="itemClassificationCode">
          {{ 'ItemMaster_TableClassification' | translateWF: 'Classification' }}
        </label>
        <csl-dropdown-master-data
          class="w-full"
          formControlName="itemClassificationCode"
          categoryCode="ItemClassification"
          (onDelete)="handleDelete($event)"
          (emitMessagesApi)="showMessagesApi($event)"
          [allowCreate]="false"
        />
      </div>
    </p-card>
  </p-panel>

  <p-panel [header]="'ItemMaster_Modal_Inventory' | translateWF: 'Inventory'" [formGroup]="itemMasterFormGroup">
    <p-card>
      <div class="form-box">
        <label for="unitOfMeasure">
          {{ 'ItemMaster_TableUnitOfMeasure' | translateWF: 'Unit of Measure' }}
        </label>
        <p-select
          formControlName="unitOfMeasure"
          [options]="_setOptionsForPrimeNg(uoms, uomRestrictValue)"
          optionValue="value"
          optionLabel="label"
          [placeholder]="'ItemMaster_SelectUnitOfMeasure' | translateWF: 'Select a Unit of Measure'"
          fluid
          class="w-full"
          [ngClass]="{
            'ng-invalid ng-dirty': submittedForm && itemMasterFormGroup.get('unitOfMeasure')?.invalid,
          }"
        />
        @if (submittedForm && itemMasterFormGroup.get('unitOfMeasure')?.invalid) {
          <div class="text-red-500 text-sm">
            <div *ngIf="itemMasterFormGroup.get('unitOfMeasure')?.errors?.['required']">Unit of Measure is required.</div>
          </div>
        }
      </div>
      <div class="form-box">
        <label for="">Procurement Item Category</label>
        <p-select [options]="procurementItemCategoryOptions" [formControl]="procurementItemCategoryReference" optionValue="id" optionLabel="name" class="w-full"> </p-select>
      </div>
    </p-card>
  </p-panel>

  @if (showGlAccountsSection) {
    <p-panel [header]="'ItemMaster_GlAccounts' | translateWF: 'GL Accounts'">
      <p-card>
        @if (canEdit) {
          @if (loadingGlAccountTree()) {
            <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
          } @else if (glAccountTreeNodes().length) {
            <div class="row-sm-start-center mb-3">
              <p-toggleswitch [ngModel]="effectiveShowSelectedGlOnly()" (ngModelChange)="showSelectedGlOnly.set($event)" [disabled]="!glAccounts().length" />
              <span>{{ 'ItemMaster_GlAccounts_SelectedOnly' | translateWF: 'Show selected only' }}</span>
            </div>
            @if (!effectiveShowSelectedGlOnly()) {
              <p class="text-sm text-gray-500 mb-2">
                {{
                  'ItemMaster_GlAccounts_Hint'
                    | translateWF
                      : 'Check the posting accounts this item can be posted to on AP
        documents.'
                }}
              </p>
            }
            <p-treeTable [value]="displayedGlAccountTreeNodes()" [scrollable]="true" scrollHeight="320px">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'ItemMaster_GlAccounts_Number' | translateWF: 'Account Number' }}</th>
                  <th>{{ 'ItemMaster_GlAccounts_Name' | translateWF: 'Name' }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                @let checkState = glAccountCheckStates().get(rowData.id);
                <tr [ttRow]="rowNode">
                  <td>
                    <p-treeTableToggler [rowNode]="rowNode" />
                    <p-checkbox
                      [binary]="true"
                      [ngModel]="checkState?.checked"
                      [indeterminate]="!!checkState?.partial"
                      [disabled]="!checkState || checkState.disabled"
                      (onChange)="toggleGlAccount(rowData, $event.checked)"
                      styleClass="p-treetable-node-checkbox"
                    />
                    <span class="ml-2">{{ rowData.accountNumber }}</span>
                  </td>
                  <td>{{ getGlAccountName(rowData) }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="2">{{ 'ItemMaster_GlAccounts_Empty' | translateWF: 'No GL accounts added' }}</td>
                </tr>
              </ng-template>
            </p-treeTable>
          } @else {
            <p-message severity="info">
              {{ 'ItemMaster_GlAccounts_NoChart' | translateWF: 'No chart of accounts is available for the selected site.' }}
            </p-message>
          }
        } @else {
          <p-table [value]="glAccounts()" dataKey="reference">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'ItemMaster_GlAccounts_Number' | translateWF: 'Account Number' }}</th>
                <th>{{ 'ItemMaster_GlAccounts_Name' | translateWF: 'Name' }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-account>
              <tr>
                <td>{{ account.number }}</td>
                <td>{{ account.name }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="2">{{ 'ItemMaster_GlAccounts_Empty' | translateWF: 'No GL accounts added' }}</td>
              </tr>
            </ng-template>
          </p-table>
        }
      </p-card>
    </p-panel>
  }

  <p-panel [header]="'ItemMaster_Modal_Files_To_Upload' | translateWF: 'Files to Upload'">
    <p-card>
      <div class="card">
        <p-toast />
        <label class="block mb-2 font-semibold">Files to Upload</label>

        <input #fileInput type="file" (change)="onFileChange($event)" accept="*/*" style="display: none" />

        <p-button label="Choose File" icon="pi pi-upload" (onClick)="fileInput.click()" [disabled]="!itemMaster" />

        @if (selectedFiles.length > 0) {
          <div class="mt-3">
            <p><strong>Selected:</strong> {{ selectedFiles[0].name }}</p>
            <p-button
              label="Upload File"
              icon="pi pi-cloud-upload"
              (onClick)="uploadFile()"
              [disabled]="!itemMaster?.itemCode"
              [loading]="isUploading"
              severity="success"
              class="mt-5"
            />
            @if (!itemMaster?.itemCode) {
              <span>
                <small> Please Save Item Master for you can upload files </small>
              </span>
            }
          </div>
        }

        <!-- Show uploaded files -->
        @if (uploadedFiles.length > 0) {
          <div class="mt-4">
            <h4>Uploaded Files</h4>
            <ul>
              @for (file of uploadedFiles; track $index) {
                <li>{{ file.name }} - {{ formatFileSize(file.size) }}</li>
              }
            </ul>
          </div>
        }
      </div>
    </p-card>
  </p-panel>
</section>
<footer>
  <p-button class="w-full" [label]="'Common_Save' | translateWF: 'Save'" (click)="onSave()" [disabled]="isLoading || !canEdit" />
  <p-button class="w-full" [label]="'Common_Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" [disabled]="isLoading" />
</footer>
